import AWN from 'awesome-notifications'

import { Dbs } from '../constants'

export const notifier = new AWN({
    labels: {
        tip: 'Consejo',
        info: 'Información',
        success: 'Exito',
        warning: 'Aviso Importante',
        alert: 'Error Detectado',
        async: 'Cargado Datos',
        confirm: 'Confirmar Acción',
        confirmOk: 'Aceptar',
        confirmCancel: 'Cancelar'
    },
    messages: {
        async: 'Por favor, espera...',
        'async-block': 'Cargado Datos'
    },
    icons: {
        enabled: true,
        prefix: '<i class="fa fas fa-fw fa-',
        suffix: '"></i>',
        tip: 'question-circle',
        info: 'info-circle',
        success: 'check-circle',
        warning: 'exclamation-circle',
        alert: 'exclamation-triangle',
        async: 'cog fa-spin',
        confirm: 'exclamation-triangle',
    }
})

export const db = new window.zango.Db(Dbs.DB, Dbs.VERSION, {

    [Dbs.COLLECTION_SESSION]: {
        rpe: true
    },

    [Dbs.COLLECTION_STATE]: {
    },

    [Dbs.COLLECTION_TMP]: {
    }
})
